import { Box } from '@branch-messenger/willow-ui'

import { PageTitle } from '@/components/page-title'
import { centsToDollar } from '@/lib/currency'
import { useBranchVerification } from '@/selectors/ewa'

import { HeaderComponentContainer } from '../styles'
import { TakeAdvance } from '../TakeAdvance/TakeAdvance'
import { AdvanceInfo } from './AdvanceInfo'
import { HeaderSubTitle } from './HeaderSubTitle'

export const HeaderComponent = () => {
  const {
    data: { availableAdvanceAmount },
  } = useBranchVerification()

  return (
    <HeaderComponentContainer>
      <Box>
        <PageTitle>
          Available Now <br />
          {centsToDollar(availableAdvanceAmount)}
        </PageTitle>
        <HeaderSubTitle />
      </Box>
      <AdvanceInfo />
      <TakeAdvance />
    </HeaderComponentContainer>
  )
}
